"use client";

import { usePathname } from "next/navigation";

interface HideOnRoutesProps {
  routes: string[];
  children: React.ReactNode;
}

export const HideOnRoutes: React.FC<HideOnRoutesProps> = ({
  routes,
  children,
}) => {
  const pathname = usePathname();

  if (routes.includes(pathname)) {
    return null;
  }

  return children;
};
